app.controller('partnerController', function ($rootScope, $scope, safeApply, partnerService) {

  $scope.syncPartnersToSendGrid = async function () {

    $scope.running = true

    const results = await partnerService.updateInsertPartnersInSGContacts()
    console.log('results :>> ', results);

    $scope.running = false

    if (results.data.success) {
      swal.fire({
        title: 'Success!',
        text: "SendGrid Contacts Synced Successfully",
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
      })
    } else {
      swal.fire({
        title: 'Error1',
        text: "Error Syncing SendGrid Contacts, tell the developer",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
      })
    }

    safeApply($scope)

  }

})